import React, { useState, useRef } from 'react';
import { Plus } from 'lucide-react';
import CanvasContextMenu from './CanvasContextMenu';

/**
 * Inline "+ Add a step" button for Simple Mode. Click opens the same
 * action picker the canvas uses (filtered to actions via the truthy
 * connectFrom flag). On select calls onSelect(typeKey).
 */
export default function AddStepButton({ label = 'Add a step', onSelect, compact = false }) {
  const [pickerCoords, setPickerCoords] = useState(null);
  const buttonRef = useRef(null);

  const handleClick = () => {
    const el = buttonRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    setPickerCoords({ x: rect.left + rect.width / 2, y: rect.bottom + 4 });
  };

  const handlePick = (typeKey) => {
    onSelect(typeKey);
    setPickerCoords(null);
  };

  return (
    <>
      <div className={`flex justify-center ${compact ? 'py-1' : 'py-1.5'}`}>
        <button
          ref={buttonRef}
          type="button"
          onClick={handleClick}
          className={`group inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border border-dashed border-gray-300 bg-white/60 text-gray-400 hover:text-gray-700 hover:border-gray-400 hover:bg-white transition text-[11.5px] font-medium`}
        >
          <Plus className="w-3 h-3" strokeWidth={2.2} />
          <span>{label}</span>
        </button>
      </div>
      {pickerCoords && (
        <CanvasContextMenu
          x={pickerCoords.x}
          y={pickerCoords.y}
          onAddNode={handlePick}
          onClose={() => setPickerCoords(null)}
          connectFrom={{ /* truthy → forces action-only picker */ source: 'simple' }}
        />
      )}
    </>
  );
}
